/* ============
 * Pickup Transformer
 * ============
 *
 * The transformer for the Pickup.
 */

import type { AssignmentResponseData } from '@/types/Models/Assignment'
import type { Pickup } from '@/types/Models/Pickup'
import AssignmentTransformer from '@/transformers/AssignmentTransformer'
import SenderAddressTransformer from '@/transformers/SenderAddressTransformer'

export default class PickupTransformer {
  /**
   * Method used to transform a fetched Pickup.
   */
  static fetch(pickup: any): Pickup {
    return {
      id: pickup.id,
      status: pickup.status,
      carrier: pickup.carrier_handle,
      instructions: pickup.pickup_instructions,
      error: pickup.error,
      identifier: pickup.pickup_identifier,
      pickupDate: pickup.pickup_date,
      createdAt: pickup.created_at,
      company: pickup.company,
      senderAddress: pickup.senderAddress ? SenderAddressTransformer.fetch(pickup.senderAddress) : null,
      assignments: pickup.assignments.map((a: AssignmentResponseData) => AssignmentTransformer.fetch(a)),
    }
  }

  /**
   * Method used to transform a fetched collection.
   */
  static fetchCollection(items: any[]) {
    return items.map((item) => this.fetch(item))
  }
}
